import MoonIcon from "@redotech/redo-icons/moon-01_filled.svg";
import SunIcon from "@redotech/redo-icons/sun.svg";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { memo, useCallback, useMemo, useState } from "react";
import { ExitOnboardingButton } from "../ui/exit-onboarding-button";
import * as headerStyles from "./onboarding-header.module.css";

export const LandingHeader = memo(function LandingHeader({
  storeName = "My Store",
  logoUrl,
  hasActiveProduct = false,
}: {
  storeName?: string;
  logoUrl?: string;
  hasActiveProduct?: boolean;
}) {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleDarkMode = useCallback(() => {
    setIsDarkMode((prev) => {
      const next = !prev;
      document.documentElement.setAttribute(
        "data-theme",
        next ? "dark" : "light",
      );
      return next;
    });
  }, []);

  const initials = useMemo(() => {
    const words = storeName.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0]![0]! + words[1]![0]!).toUpperCase();
    }
    return (words[0]?.[0] ?? "").toUpperCase();
  }, [storeName]);

  return (
    <header className={headerStyles.header}>
      <div className={headerStyles.navBar}>
        <div className={headerStyles.brandGroup}>
          <div className={headerStyles.profileAvatar}>
            {logoUrl ? (
              <img
                alt={storeName}
                className={headerStyles.profileImage}
                src={logoUrl}
              />
            ) : (
              <span className={headerStyles.profileInitials}>{initials}</span>
            )}
          </div>
          <span className={headerStyles.storeName}>{storeName}</span>
        </div>
        <div className={headerStyles.rightGroup}>
          <div className={headerStyles.themeTag} onClick={toggleDarkMode}>
            {isDarkMode ? (
              <RedoIcon className={headerStyles.themeIcon} Icon={SunIcon} />
            ) : (
              <RedoIcon className={headerStyles.themeIcon} Icon={MoonIcon} />
            )}
          </div>
          {hasActiveProduct && (
            <ExitOnboardingButton
              className={headerStyles.exitTag}
              skipPrompt
              textClassName={headerStyles.exitText}
            />
          )}
        </div>
      </div>
      <div className={headerStyles.divider} />
    </header>
  );
});
